import classNames from 'classnames';
import Link from 'next/link';
import * as React from 'react';
import {
  MultipleLineTruncate,
  SingleLineTruncate,
} from '../../../../../components/LineTruncate';
import ProductTag from '../../tags/ProductTag';
import Price from '../../texts/Price';
import TicketCount from '../../texts/TicketCount';
import TicketExpiration from '../../texts/TicketExpiration';
import css from './ProductCard.module.scss';
import { buildUrl } from 'src/utils/request-url';

interface Props {
  className?: string;
  name: string;
  description: string;
  scheme: number;
  thumbnailUrl: string;
  url: string;
  price: number;
  ticketCount?: number;
  ticketExpiration?: number;
}

const ProductCard = (props: Props) => {
  const isSubscription = props.scheme === 0;
  const isTicketBook = props.scheme === 1;
  return (
    <div className={classNames(css.ProductCard, props.className)}>
      <Link
        href={buildUrl(props.url, 'next')} // Link互換(/reserveがあるなら削除する)再変換
        prefetch={false}
        className={css.ProductCard__Link}
      >
        <div className={css.ProductCard__Summary}>
          {props.thumbnailUrl && (
            <div className={css.ProductCard__Thumbnail}>
              <img
                className={css.ProductCard__ThumbnailImage}
                src={props.thumbnailUrl}
                alt={props.name}
              />
            </div>
          )}
          <div className={css.ProductCard__Texts}>
            <div className={css.ProductCard__Name}>
              <SingleLineTruncate maxLine={2} text={props.name} />
            </div>
            <div className={css.ProductCard__Description}>
              <MultipleLineTruncate maxLine={3} text={props.description} />
            </div>
          </div>
        </div>
        <div className={css.ProductCard__Footer}>
          <div>
            <ProductTag scheme={props.scheme} />
          </div>
          <div className={css.ProductCard__FooterRight}>
            {isTicketBook && (
              <div className={css.ProductCard__FooterRightFirst}>
                <TicketCount count={props.ticketCount!} />
                <TicketExpiration
                  className={css.ProductCard__Expiration}
                  expiration={props.ticketExpiration!}
                />
              </div>
            )}
            <Price
              className={css.ProductCard__Price}
              price={props.price}
              isMonthly={isSubscription}
            />
          </div>
        </div>
      </Link>
    </div>
  );
};

export default ProductCard;
